import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

import errorBoundary from '@ifeng-fe/errorBoundary';

class Slider extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    constructor(props) {
        super(props);

        const { content } = this.props;

        this.state = {
            slideItem: content,
        };
    }

    rotatePrev = (nums, k) => {
        for (let i = 0; i < k; i++) {
            nums.unshift(nums.pop());
        }

        this.setState({
            slideItem: [...nums],
        });
    };

    // rotatePrev = (nums, k) => {
    //   const n = nums.length;
    //   let tmpEnd = 0;
    //   let tmpPrev = 0;

    //   for (let i = 0; i < k; i++) {
    //     tmpEnd = nums[n - 1];
    //     for (let r = 0; r < n; r++) {
    //       tmpPrev = nums[r];
    //       nums[r] = tmpEnd;
    //       tmpEnd = tmpPrev;
    //     }
    //   }

    //   this.setState({
    //     slideItem: [...nums],
    //   });
    // };

    rotateNext = (nums, k) => {
        for (let i = 0; i < k; i++) {
            nums.push(nums.shift());
        }

        this.setState({
            slideItem: [...nums],
        });
    };

    handleShowPrevSlide = slideItem => {
        this.rotatePrev(slideItem, 1);
    };

    handleShowNextSlide = slideItem => {
        this.rotateNext(slideItem, 1);
    };

    /**
     * 渲染组件
     */
    render() {
        return (
            <div className={styles.sliderContainer}>
                <h3>
                    <img src="http://y1.ifengimg.com/a/2015/0819/syj/t06.gif" width="118" height="23" />
                </h3>
                <div className={styles.scroll}>
                    <div
                        className={styles.btnL}
                        id={styles.btnLeft}
                        onClick={this.handleShowPrevSlide.bind(this, this.state.slideItem)}
                    />
                    <div
                        className={styles.btnR}
                        id={styles.btnRight}
                        onClick={this.handleShowNextSlide.bind(this, this.state.slideItem)}
                    />
                    <div className={styles.scroll0} id={styles.gallery}>
                        <div className={styles.largePicDiv}>
                            <ul className={styles.clearfix} id={styles.starList}>
                                {this.state.slideItem.map((item, index) => {
                                    if (index === 2) {
                                        return (
                                            <li className={styles.cur} key={index}>
                                                <span className={styles.current} />
                                                <a href="" target="_blank">
                                                    <img
                                                        src={item.thumbnail}
                                                        width="400"
                                                        height="400"
                                                        alt={item.title}
                                                    />
                                                </a>
                                                <h4>{item.title}</h4>
                                                <div className={styles.c6_over}>
                                                    <div className={styles.tBg} />
                                                    <div className={styles.txt}>
                                                        <div className={styles.tit}>
                                                            <div>
                                                                <a href="" target="_blank" title={item.title}>
                                                                    {item.title}
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <p>{item.summary}</p>
                                                    </div>
                                                </div>
                                            </li>
                                        );
                                    } else {
                                        return (
                                            <li className="" key={index}>
                                                <span className={styles.pic_bg} />
                                                <a href="" target="_blank">
                                                    <img
                                                        src={item.thumbnail}
                                                        width="400"
                                                        height="400"
                                                        alt={item.title}
                                                    />
                                                </a>
                                                <h4>{item.title}</h4>
                                                <div className={styles.c6_over}>
                                                    <div className={styles.tBg} />
                                                    <div className={styles.txt}>
                                                        <div className={styles.tit}>
                                                            <div>
                                                                <a href="" target="_blank" title={item.title}>
                                                                    {item.title}
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <p>{item.summary}</p>
                                                    </div>
                                                </div>
                                            </li>
                                        );
                                    }
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Slider);
